import React from "react"

const DownloadIcon = (props) => (
	<svg width={props.size} height={props.size} fill={props.color} stroke={props.color} viewBox="0 0 512 512">
		<path d="M368 224l-128 128-128-128h80v-192h96v192zM240 352h-240v128h480v-128h-240zM448 416h-64v-32h64v32z"></path>
	</svg>
)

export default DownloadIcon
